import apiClient from "@repo/ui/lib/apiClient";
import type { ApiResponse } from "@repo/ui/types";

export interface SSRPayload {
  name: string;
  quantity: number;
  ssrCode: string;
  ssrKey: string;
  passengerKey: string;
  journeyKey?: string;
}

export interface AddExtrasToBookingInStateBody {
  baggages: SSRPayload[];
  currency: string;
  isUserStaff: boolean;
}

export interface AddExtrasResponseData {
  success: boolean;
  message?: string;
}

export type AddExtrasToBookingInStateResponse = ApiResponse<AddExtrasResponseData>;

export async function addExtrasToBookingInState(
  payload: AddExtrasToBookingInStateBody,
  tabSessionId: string | null,
): Promise<AddExtrasToBookingInStateResponse> {
  try {
    const response = await apiClient<AddExtrasToBookingInStateResponse>("/v1/bookings/extras", {
      method: "POST",
      headers: {
        accept: "application/json",
      },
      body: payload,
      withAuth: true,
      tabSessionId,
    });

    if (!response) {
      throw new Error(`Failed to add extras to booking in-state: ${response}`);
    }

    return response;
  } catch (error) {
    // Centralized error shaping
    throw new Error(
      `AddExtrasToBooking failed: ${error instanceof Error ? error.message : "Unknown error"}`,
    );
  }
}
